/**
 * Map Error Boundary Component
 *
 * Handles map-specific errors and fallback UI
 * following Single Responsibility Principle
 */

import React from 'react';
import {MapConfigurationService} from '../../../Services/map/MapConfigurationService';

export interface MapErrorBoundaryProps {
  children: React.ReactNode;
  className?: string;
}

export const MapErrorBoundary: React.FC<MapErrorBoundaryProps> = ({
  children,
  className = ''
}) => {
  const mapConfig = MapConfigurationService.getInstance();

  if (!mapConfig.isTokenValid()) {
    return (
      <div className={`flex items-center justify-center h-96 bg-gray-100 rounded-lg ${className}`}>
        <div className="text-center">
          <div className="text-red-500 text-lg font-semibold mb-2">
            خطأ في إعداد الخريطة
          </div>
          <div className="text-gray-600">
            يرجى إضافة VITE_MAPBOX_ACCESS_TOKEN في ملف البيئة
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default MapErrorBoundary;
